import { StaticToggleService } from 'util/services';
import { CommonUtilsService } from 'util/util';
import { HelpBlurbDataStore } from 'sharebase/dataStores/help-blurb-datastore';
import { InterfaceFor } from 'util/domain'
import { HelpBlurb } from 'sharebase/domain';

export class HelpBlurbFactory {
	public static $inject = [
		'utils',
		'sbHelpBlurbDataStore'
	];

	constructor(
        private readonly utils:CommonUtilsService,
		private readonly sbHelpBlurbDataStore:HelpBlurbDataStore
	) {
	}

	public create(blurbText:string, blurbId:string) {
		return new HelpBlurb(
			blurbText,
			blurbId,
			this.utils,
			this.sbHelpBlurbDataStore
		);
    }
}

class NullHelpBlurbFactory implements InterfaceFor<HelpBlurbFactory> {
	public create(blurbText: string, blurbId: string): HelpBlurb {
		return null;
	}
}

export function HelpBlurbFactoryFactory(
	staticToggleService:StaticToggleService,
	utils:CommonUtilsService,
	sbHelpBlurbDataStore:HelpBlurbDataStore
){
	if(staticToggleService.isEnabled('help-blurbs')) {
		return new HelpBlurbFactory(utils, sbHelpBlurbDataStore);
	}
	else {
		return new NullHelpBlurbFactory();
	}
}

HelpBlurbFactory.$inject =  [
	'staticToggleService',
	'utils',
	'sbHelpBlurbDataStore'
];


// WEBPACK FOOTER //
// ./src/sharebase/factories/helpBlurbFactory.ts